import { Component, Input, OnDestroy, OnInit,} from '@angular/core';
import { Subject, forkJoin, map } from 'rxjs';
import { ModalService } from './../../../../../services/modal.service';
import { AlertService } from './../../../../../services/alert.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ObjetivoService } from '../../../services/objetivo.service';
import { RiesgosService } from '../../../services/riesgos.service';
import { CatComunService } from 'src/app/modulos/catalogos-admin/services/cat-comun.service';
import { Riesgos } from '../../../models/riesgos';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { DatePipe } from '@angular/common';
import { AccionService } from '../../../services/accion.service';
import { PlanAccionService } from '../../../services/plan.accion.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { PlanesInstitucionalesAnualesService } from 'src/app/modulos/catalogos-admin/services/planes-institucionales-anuales.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { UsuarioRedux } from 'src/app/models/usuario.model';
@Component({
  selector: 'app-riesgo-plan-accion',
  templateUrl: './riesgo-plan-accion.component.html',
  styleUrls: ['./riesgo-plan-accion.component.css']
})
export class RiesgoPlanAccionComponent implements OnInit, OnDestroy {
  public formRiesgo: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public submitted = false;
  public dataProcesosIndicadores: any = [];
  public dataObjetivo: any = [];
  public dataEstrategiaObjetivo: any = [];
  public dataPlanAccion: any = [];
  public dataLineaAccionR: any = [];
  private idDeleteRegister: number = 0;
  private ipAddress!: string;
  public modalRiesgoPlanAccion: string = 'modalRiesgoPlanAccion'
  public modalGestionPlanAccion: string = 'modalGestionPlanAccion'
  public nameApp = 'Riesgos de Planes de Acción';
  public nameAppGestionRL = 'Acciones de Riesgos';
  public selectItems: any = [];
  public idSprAmbiente: number = 0;
  public dataRiesgo: any[] = [];
  public dataLineaAccionRiesgo: any = [];
  public dataCatComun!: any;
  public calificacionTotal!: any;
  public idRecursivoEdr: number = 290;
  public riesgos!: any;
  public idRiesgoSeleccionado: number = 0;
  public idLineaAccionSeleccionado: number = 0;
  public itemEstadoRiesgo: any = [];
  public idRiesgo!: any;
  public riesgosOutput!: any;
  public dataEquipoGerencial!: any;
  public dataTipoParticpacion: any = [];
  public dataPersonalElemento!: any;
  public dataResponsableProceso: any = [];
  pipe = new DatePipe('en-US');
  hoy = new Date();
  public currentAmbiente!: any;
  public dataAccion: any[] = [];
  public nameElemento!: any;
  public estadoActivo: number = 1;
  public planAnioSeleccionadoRedux: any = null;
  public idSprAnio: number = 0;
  public idSprPlanAnio: number = 0;
  private idSprUsuario: number = 0;
  public dataPlanesAnios: any = null;
  public dataResponsable: any = [];
  public elementoActual = "";
  public dataElementoActual = ""
  public idSprNivel: number = 0;
  readonly constant = ConstantsCatalogosIdService;
  idSprEstructuraDesglose = ConstantsCatalogosIdService.ID_COMUNES_ESTRUCTUTA_DESGLOSE;
  idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;


  @Input() set init(planAccion: any) {
    this.nameElemento = planAccion
    //this.initApp(planAccion);
  }
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();



  constructor(
    public modal: ModalService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private objetivoService: ObjetivoService,
    private riesgoService: RiesgosService,
    private catalogoComunService: CatComunService,
    private planAccionService: PlanAccionService,
    private equipoGerencialService: EquipoGerencialService,
    private participanteElementoService: ParticipanteElementoService,
    private accionService: AccionService,
    private planAniosService: PlanesInstitucionalesAnualesService,
    public store: Store<AppState>,
  ) {
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.itemEstadoRiesgo = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Abierto' },
      { value: 2, label: 'Cerrado' },
    ];
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response) => {// redux
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.initApp();
    });
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }

  initApp() {
    if (this.nameElemento == 'planes-accion') {
      this.listPlanAnios();
      this.listEquipoGerencial();
    }
    this.getIpPublic();
    this.setDataTable();
    this.getDataCatalogoComun();
    this.setFromObjetivo(this.dataElementoActual);
  }

  listPlanAnios() {
    this.planAniosService.list('?idSprAnio=' + this.idSprAnio).subscribe({
      next: (resp) => {
        this.dataPlanesAnios = resp;
        this.idSprPlanAnio = resp[0].idSprPlanAnio;
        this.getDataAll(this.idSprPlanAnio);
      }
    })
  }

  getDataAll(idSprPlanAnioSelected: number) {
    forkJoin([
      this.objetivoService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + idSprPlanAnioSelected + '&estado=' + this.estadoActivo),
      this.planAccionService.list('?estado=' + this.estadoActivo),
      this.riesgoService.list(),
      this.participanteElementoService.list(),
      this.equipoGerencialService.list()
    ]).pipe(map(
      ([dataObjetivo, dataPlanAccion, dataRiesgo, dataPersonalElemento, dataEquipoGerencial]) => {
        this.dataObjetivo = dataObjetivo;
        this.dataPlanAccion = dataPlanAccion;
        this.dataRiesgo = dataRiesgo;
        this.dataPersonalElemento = dataPersonalElemento;
        this.dataEquipoGerencial = dataEquipoGerencial;
        this.mapeoRiesgoPlan();
      })).subscribe();
  }

  mapeoRiesgoPlan() {
    let indiceUno = 0;
    let dataPlanAccionMap: any = [];
    let dataRiesgoMap: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataPlanAccion.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataPlanAccion[j].idSprObjetivo) {
          for (let k = 0; k < this.dataRiesgo.length; k++) {
            if (this.dataRiesgo[k].idSprPlanAccion == this.dataPlanAccion[j].idSprPlanAccion) {
              for (let w = 0; w < this.dataPersonalElemento.length; w++) {
                if (this.dataPersonalElemento[w].idSprRiesgo == this.dataRiesgo[k].idSprRiesgo) {
                  for (let x = 0; x < this.dataEquipoGerencial.length; x++) {
                    if ((this.dataEquipoGerencial[x].idSprEquipoGerencial == this.dataPersonalElemento[w].idSprEquipoGerencial) && (this.dataPersonalElemento[w].estado == 1)) {
                      dataRiesgoMap.push({
                        idSprPlanAccion: this.dataPlanAccion[j].idSprPlanAccion,
                        namePlanAccion: this.dataPlanAccion[j].nombre,
                        idSprRiesgo: this.dataRiesgo[k].idSprRiesgo,
                        nombre: this.dataRiesgo[k].nombre,
                        descripcion: this.dataRiesgo[k].descripcion,
                        probabilidad: this.dataRiesgo[k].probabilidad,
                        impacto: this.dataRiesgo[k].impacto,
                        calificacion: this.dataRiesgo[k].calificacion,
                        costoPotencial: this.dataRiesgo[k].costoPotencial,
                        idSprEstructuraEdr: this.dataRiesgo[k].idSprEstructuraEdr,
                        fechaIdentificacion: this.dataRiesgo[k].fechaIdentificacion,
                        fechaOcurrencia: this.dataRiesgo[k].fechaOcurrencia,
                        fechaCierre: this.dataRiesgo[k].fechaCierre,
                        estadoRiesgo: this.dataRiesgo[k].estadoRiesgo,
                        estado: this.dataRiesgo[k].estado,
                        fecha: this.dataRiesgo[k].fecha,
                        idSprEquipoGerencial: this.dataEquipoGerencial[x].idSprEquipoGerencial,
                        gradoNombres: this.dataEquipoGerencial[x].gradoNombres,
                        idSprParticipanteElemento: this.dataPersonalElemento[w].idSprParticipanteElemento
                      }); indiceUno++;
                    }
                  }
                }
              }
            }
          }

          dataPlanAccionMap.push({
            idSprPlanAccion: this.dataPlanAccion[j].idSprPlanAccion,
            namePlanAccion: this.dataPlanAccion[j].nombre,
            fechaInicio: this.dataObjetivo[i].fechaInicio,
            fechaFin: this.dataObjetivo[i].fechaFin,
            dataRiesgoMap: dataRiesgoMap
          }); dataRiesgoMap = [];
        }
      }
    }
    this.dataLineaAccionRiesgo = dataPlanAccionMap
  }



  get appForm() {
    return this.formRiesgo.controls;
  }


  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }


  setFromObjetivo(dataElementoActual: any) {
    let idSprPlanAccion = null;
    let fechaInicio = null;
    let fechaFin = null;
    idSprPlanAccion = dataElementoActual.idSprPlanAccion
    fechaInicio = dataElementoActual.fechaInicio
    fechaFin = dataElementoActual.fechaFin
    this.formRiesgo = this.fb.group({
      idSprPlanAccion: [idSprPlanAccion],
      idSprRiesgo: [],
      idSprEstructuraEdr: ['', [Validators.required]],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaIdentificacion: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      probabilidad: ['', [Validators.required]],
      impacto: ['', [Validators.required]],
      calificacion: [],
      costoPotencial: ['', [Validators.required]],
      fechaOcurrencia: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      fechaCierre: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      estadoRiesgo: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
  }

  validacionFechas(fecha1: Date, fecha2: Date, fecha3: Date) {
    let alerta1
    let alerta2
    if (fecha1 > fecha2) {
      alerta1 = this.alert.warning(
        'Atención!',
        'La fecha IDENTIFICACIÓN no puede ser mayor a la fecha OCURRENCIA'
      );
      return this.onSubmit()
    }
    if (fecha2 > fecha3) {
      alerta2 = this.alert.warning(
        'Atención!',
        'La fecha OCURRENCIA no puede ser mayor a la fecha CIERRE'
      );
      //return alerta2
    }
  }


  onSubmit() {
    let stateInsert: boolean = false;
    let idSprRiesgoInsertado: number = 0;
    this.submitted = true;
    this.formRiesgo.value.usuario = this.idSprUsuario;
    this.formRiesgo.value.ip = this.ipAddress;
    this.formRiesgo.value.nombre = this.formRiesgo.value.nombre;
    this.calificacionTotal = this.calificacion();
    this.formRiesgo.value.calificacion = this.calificacionTotal;
    let fechaIdentificacion = this.formRiesgo.value.fechaIdentificacion;
    let fechaOcurrencia = this.formRiesgo.value.fechaOcurrencia;
    let fechaCierre = this.formRiesgo.value.fechaCierre;
    this.validacionFechas(fechaIdentificacion, fechaOcurrencia, fechaCierre);

    if (!this.formRiesgo.invalid && (fechaIdentificacion <= fechaOcurrencia) && (fechaOcurrencia <= fechaCierre)) {

      if (this.formRiesgo.value.idSprRiesgo == null) {
        this.riesgoService.create(this.formRiesgo.value).subscribe(
          (resp) => {
            stateInsert = true;
            idSprRiesgoInsertado = resp.idSprRiesgo;
            let dataParticpante = {
              idSprEquipoGerencial: this.formRiesgo.value.idSprEquipoGerencial,
              fechaInicio: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
              usuario: this.idSprUsuario,
              idSprRiesgo: idSprRiesgoInsertado,
              estado: 1,
              ip: this.ipAddress,
            }
            if (stateInsert) {
              this.participanteElementoService.create(dataParticpante).subscribe(responseParticipaELement => {
                stateInsert = true;
              },
                (error) => {
                  stateInsert = false;
                });
            }
            this.initApp();
            this.modal.close();
            this.alert.createOk();

          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.riesgoService.update(this.formRiesgo.value).subscribe(
          (resp) => {
            if (this.formRiesgo.value.idSprEquipoGerencial != this.formRiesgo.value.idSprEquipoGerencialAnterior) {
              let estadoParticipante: boolean = true;
              if (this.formRiesgo.value.idSprEquipoGerencialAnterior != null) {
                let dataParticipanteELemento = {
                  idSprParticipanteElemento: this.formRiesgo.value.idSprParticipanteElemento,
                  fechaFin: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
                  usuario: this.idSprUsuario,
                  estado: 2,
                  ip: this.ipAddress,
                }
                this.participanteElementoService.update(dataParticipanteELemento).subscribe(responseParticipaELement => {
                },
                  (error) => {
                    estadoParticipante = false;
                    stateInsert = false;
                  });
              }
              if (estadoParticipante) {
                let dataParticipElemento = {
                  idSprEquipoGerencial: this.formRiesgo.value.idSprEquipoGerencial,
                  fechaInicio: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
                  usuario: this.idSprUsuario,
                  idSprRiesgo: this.formRiesgo.value.idSprRiesgo,
                  estado: 1,
                  ip: this.ipAddress
                }
                this.participanteElementoService.create(dataParticipElemento).subscribe(responseParticipaELement => {
                },
                  (error) => {
                    stateInsert = false;
                  });
              }
            }
            //this.listObjetivos();
            this.initApp();
            this.modal.close();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
    }
  }


  delete(id: number) {
    this.idDeleteRegister = id;
    this.modal.open('delPlanAccion');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.accionService.list(`?idSprRiesgo=${this.idDeleteRegister}&delLog=N`)
        .subscribe(response => {
          if (response.length < 1) {

            let errorDeleteState: boolean = false;
            let dataDeleteParticipElementos = {
              usuario: this.idSprUsuario,
              idSprParticipanteElemento: 0,
              ip: this.ipAddress,
              delLog: 'S'
            }
            let dataDeleteProceso = {
              idSprRiesgo: this.idDeleteRegister,
              usuario: this.idSprUsuario,
              ip: this.ipAddress,
              delLog: 'S'
            }
            if (this.idDeleteRegister > 0) {
              let participantesElementos = [];
              this.participanteElementoService.list(`?idSprRiesgo=${this.idDeleteRegister}`).subscribe(response => {
                participantesElementos = response;
                // Foreach 2
                participantesElementos.forEach(itemParticipanteElement => {
                  dataDeleteParticipElementos.idSprParticipanteElemento = itemParticipanteElement.idSprParticipanteElemento;
                  this.participanteElementoService.delete(dataDeleteParticipElementos).subscribe({
                    next: responseDelete => {
                      this.riesgoService.delete(dataDeleteProceso).subscribe({
                        next: responseDelete => {
                          this.initApp();
                        },
                        error: (error) => {
                          errorDeleteState = true;
                        }
                      })

                    },
                    error: (error) => {
                      errorDeleteState = true;
                      dataDeleteProceso.delLog = 'N';
                      this.riesgoService.delete(dataDeleteProceso).subscribe({
                        next: responseDelete => {
                        },
                        error: (error) => {
                          errorDeleteState = true;
                        }
                      })
                    }
                  })
                });// Fin forEach 2
              });
            }
            if (!errorDeleteState) {
              //this.listObjetivos();
              this.initApp();
              this.setDataTable();
              //this.setForm();
              this.alert.deleteOk();
              this.modal.close();
            } else {
              this.alert.deleteError();
            }
          } else {
            this.alert.warning('Atención!', "No se puede borrar este registro, existe ACCIONES relacionadas!")
            this.modal.close();
          }
        });
    } else {
      this.alert.warning('Atención!', "Ocurrió un error al intentar borrar el registro");
      this.modal.close();
    }
  }

  edit(obj: Riesgos,dataLineaAccionRiesgo:any) {
    this.elementoActual = obj.namePlanAccion;
    this.setFromObjetivo(dataLineaAccionRiesgo);//fechas
    this.formRiesgo.patchValue({
      idSprPlanAccion: obj.idSprPlanAccion,
      idSprRiesgo: obj.idSprRiesgo,
      idSprEstructuraEdr: obj.idSprEstructuraEdr,
      idSprEquipoGerencial: obj.idSprEquipoGerencial,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      fechaIdentificacion: obj.fechaIdentificacion,
      probabilidad: obj.probabilidad,
      impacto: obj.impacto,
      calificacion: obj.calificacion,
      costoPotencial: obj.costoPotencial,
      fechaOcurrencia: obj.fechaOcurrencia,
      fechaCierre: obj.fechaCierre,
      estadoRiesgo: obj.estadoRiesgo,
      estado: obj.estado,
    });
    this.modal.open(this.modalRiesgoPlanAccion);

  }

  getDataCatalogoComun() {
    this.catalogoComunService.list('?spr_idSprComun=' + this.idSprEstructuraDesglose)
      .subscribe(resp => {
        this.dataCatComun = resp;
      })
  }

  getDataDependiente(dataObj: any, spr_idSprComun: any = null) {
    let stateOptionTipo = false;

    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprComun == spr_idSprComun) {
        dependientes.push(
          {
            idSprComun: row.idSprComun,
            nombre: row.nombre,
            descripcion: row.descripcion,
            spr_idSprComun: row.spr_idSprComun,
            estado: row.estado,
          });
      }
    });
    return dependientes;
  }

  calificacion() {
    let probabilidad: any;
    let impacto: any;
    let totalCalificacion: any;

    probabilidad = this.formRiesgo.value.probabilidad;
    impacto = this.formRiesgo.value.impacto;
    totalCalificacion = (probabilidad * impacto) / 100;
    return totalCalificacion;
  }
  /********************************** EQUIPO GERENCIAL************************************/
  listEquipoGerencial() {
    this.equipoGerencialService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprTipoParticipante=${this.idSprTipoParticipante}&estado=${1}`)
      .subscribe((resp) => {
        this.dataResponsable = resp;
      });
  }

  getTipoParticipacion() {
    this.catalogoComunService.list().subscribe(respTipoParticipa => {
      this.dataTipoParticpacion = respTipoParticipa;
      this.mapeoEquipoGerencialTipoParticipa();
    })
  }

  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if ((this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun) && (this.dataEquipoGerencial[i].estado == 1)) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  openModal(row: any) {
    this.elementoActual = row.namePlanAccion;
    this.submitted = false
    this.formRiesgo.reset();
    this.setFromObjetivo(row);
    this.modal.open(this.modalRiesgoPlanAccion);
  }

  openModalGestion(row: any) {
    this.onResetForm();
    this.idRiesgoSeleccionado = row
    this.modal.open(this.modalGestionPlanAccion);
  }

  onResetForm() {
    this.submitted = false;
    this.formRiesgo.reset();
  }

}
